import * as React from 'react';
import autobind from 'autobind-decorator';

import { RoleEditorView } from './role-editor.view';
import { RoleListDataService } from 'src/app/general/roles/list/role-list.data';

interface RoleEditorControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: RoleSummary | null) => void;
	setBusy(isBusy: boolean);
	label?: string;
	required?: boolean;
	roleList?: number[];
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class RoleEditorController extends React.Component<RoleEditorControllerProps, any> {

	protected roleDataService: RoleListDataService;

	constructor(props) {
		super(props);
		this.roleDataService = RoleListDataService.make();
	}

	@autobind
	protected roleQuery(q?: string): Promise<QueryResult<RoleSummary>> {
		return new Promise<QueryResult<RoleSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.roleDataService.addFilter('isRole', 'eq', true);

			if (this.props.roleList && this.props.roleList.length > 0) {
				this.roleDataService.addFilter("id", 'not-in', this.props.roleList);
			}

			this.roleDataService.addSorting('id', 'asc', true);
			this.roleDataService.searchKeywords = q;
			this.roleDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.roleDataService.count
					});
				});
		});
	}

	render() {
		return (
			<RoleEditorView
				roleRequest={{ query: this.roleQuery, dataSet: this.roleDataService }}
				onGetErrorMessage={this.props.onGetErrorMessage}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/list/parts/role-editor.controller.tsx